<template>
  <v-switch
    v-model="localModelValue"
    v-bind="{ ...$attrs, ...commonAttrs }"
    v-on="$listeners"
    :label="capitalize(label || '')"
  >
    <template v-for="(_, scopedSlotName) in $scopedSlots" #[scopedSlotName]="slotData">
      <slot :name="scopedSlotName" v-bind="slotData" />
    </template>
    <template v-for="(_, slotName) in $slots" #[slotName]>
      <slot :name="slotName" />
    </template>
  </v-switch>
</template>

<script>
import { capitalize } from 'lodash';

export default {
  name: 'BaseSwitch',
  inheritAttrs: false,
  model: {
    prop: 'modelValue',
    event: 'update:modelValue',
  },
  props: {
    label: {
      type: String,
      default: undefined,
    },
    modelValue: {
      type: [Boolean, Array],
      default: false,
    },
  },
  computed: {
    localModelValue: {
      get: function() {
          return this.modelValue;
      },
      set: function(value) {
          this.$emit('update:modelValue', value);
      }
    },
    commonAttrs() {
      return {
        hideDetails: this.$attrs.hideDetails || 'auto',
        color: 'primary',
      };
    },
  },
  methods: {
    capitalize,
  },
}
</script>
<style lang="scss" scoped>
 .v-input--selection-controls::v-deep {
  margin-top: 0px;
  padding-top: 0px;
}
</style>